const state = () => ({
  activeTab: 0,
  // 创建听写任务的单词列表
  wordListForCreate: [],
  // 听写的单词列表
  wordListForDictation: [],
  // 单词库的一级模块列表
  firstModuleList: [],
  // 单词库的当前一级模块
  activeModule: null,
  // 单词库的当前模块下的书籍列表
  bookList: [],
  // 单词库的当前书籍
  activeBook: null,
  // 单词库的当前书籍下的单词题组列表
  wordGroupList: [],
  // 单词库的当前单词题组
  activeWordGroup: null,
  // 单词库的当前查看详情的单词
  activeWord: null,
  // 单词听写任务的单词列表
  wordDicationList: [],
  // 单词听写任务详情
  reportDetails: null,
  // 当前听写任务信息（用于跳转批改报告等场景）
  dictationTaskInfo: null
})

const getters = {
  activeTab: state => state.activeTab,
  wordListForCreate: state => state.wordListForCreate,
  wordListForDictation: state => state.wordListForDictation,
  firstModuleList: state => state.firstModuleList,
  activeModule: state => state.activeModule,
  bookList: state => state.bookList,
  activeBook: state => state.activeBook,
  wordGroupList: state => state.wordGroupList,
  activeWordGroup: state => state.activeWordGroup,
  activeWord: state => state.activeWord,
  selectWords: state => {
    const wordList = []
    state.wordGroupList.forEach(item => {
      item.wordList.forEach(word => {
        if (word.isSelect) {
          wordList.push(word)
        }
      })
    })
    return wordList
  },
  wordDicationList: state => state.wordDicationList,
  reportDetails: state => state.reportDetails,
  dictationTaskInfo: state => state.dictationTaskInfo
}

const mutations = {
  SET_ACTIVE_TAB: (state, activeTab) => {
    state.activeTab = activeTab
  },
  SET_WORD_LIST_FOR_CREATE(state, wordList) {
    state.wordListForCreate = wordList
  },
  SET_WORD_LIST_FOR_DICTATION(state, wordList) {
    state.wordListForDictation = wordList
  },
  SET_FIRST_MODULE_LIST(state, moduleList) {
    console.log('mutations moduleList', moduleList)
    state.firstModuleList = moduleList
  },
  SET_ACTIVE_MODULE(state, module) {
    state.activeModule = module
  },
  SET_BOOK_LIST(state, bookList) {
    state.bookList = bookList
  },
  SET_ACTIVE_BOOK(state, book) {
    state.activeBook = book
  },
  SET_WORD_GROUP_LIST(state, groupList) {
    state.wordGroupList = groupList
  },
  SET_ACTIVE_WORD_GROUP(state, group) {
    state.activeWordGroup = group
  },
  SET_ACTIVE_WORD(state, word) {
    state.activeWord = word
  },
  SET_WORD_DICTATION_LIST(state, wordList) {
    state.wordDicationList = wordList
  },
  SET_REPORT_DETAILS(state, reportDetails) {
    state.reportDetails = reportDetails
  },
  SET_DICTATION_TASK_INFO(state, taskInfo) {
    state.dictationTaskInfo = taskInfo
  }
}

const actions = {
  setActiveTab({ commit }, activeTab) {
    commit('SET_ACTIVE_TAB', activeTab)
  },
  setWordListForCreate({ commit }, wordList) {
    // 将重复的单词打上标记
    const processedWordList = wordList.map((item, index, list) => {
      const isRepeat = list.some((otherItem, otherIndex) => otherIndex !== index && otherItem.name === item.name)
      return {
        ...item,
        repeat: isRepeat
      }
    })
    commit('SET_WORD_LIST_FOR_CREATE', processedWordList)
  },
  setWordListForDictation({ commit }, wordList) {
    commit('SET_WORD_LIST_FOR_DICTATION', wordList)
  },
  setFirstModuleList({ commit }, moduleList) {
    console.log('actions moduleList', moduleList)
    commit('SET_FIRST_MODULE_LIST', moduleList)
  },
  setActiveModule({ commit }, module) {
    commit('SET_ACTIVE_MODULE', module)
  },
  setBookList({ commit }, bookList) {
    commit('SET_BOOK_LIST', bookList)
  },
  setActiveBook({ commit }, book) {
    commit('SET_ACTIVE_BOOK', book)
  },
  setWordGroupList({ commit }, wordGroupList) {
    commit('SET_WORD_GROUP_LIST', wordGroupList)
  },
  setActiveWordGroup({ commit }, wordGroup) {
    commit('SET_ACTIVE_WORD_GROUP', wordGroup)
  },
  setActiveWord({ commit }, word) {
    commit('SET_ACTIVE_WORD', word)
  },
  resetWordSelect({ getters, dispatch }) {
    const wordGroup = getters.wordGroupList.map(item => {
      // 重置题组的全选状态
      const newItem = { ...item, isSelectAll: false }
      // 重置每个单词的选中状态
      if (Array.isArray(newItem.wordList)) {
        newItem.wordList = newItem.wordList.map(word => ({
          ...word,
          isSelect: false
        }))
      }
      return newItem
    })
    console.log('resetWordSelect', wordGroup)
    dispatch('setWordGroupList', wordGroup)
  },
  setWordDictionList({ commit }, wordList) {
    commit('SET_WORD_DICTATION_LIST', wordList)
  },
  setReportDetails({ commit }, reportDetails) {
    commit('SET_REPORT_DETAILS', reportDetails)
  },
  setDictationTaskInfo({ commit }, taskInfo) {
    commit('SET_DICTATION_TASK_INFO', taskInfo)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
